// Single source of truth for every floor-plan layout element type — the "Add Element" modal's
// grouped picker, the icon set, and LayoutElementShape's label/sizing/aspect-lock all read from
// this same catalog instead of keeping their own separate lists in sync by hand.

export const ELEMENT_CATEGORIES = [
  {
    category: 'Doors',
    options: [
      { value: 'front_door', label: 'Front Door', width: 60, height: 15 },
      { value: 'rear_door', label: 'Rear Door', width: 60, height: 15 },
      { value: 'kitchen_door', label: 'Kitchen Door', width: 60, height: 15 },
      { value: 'toilet_door', label: 'Toilet Door', width: 60, height: 15 },
      { value: 'store_room_door', label: 'Store Room Door', width: 60, height: 15 },
    ],
  },
  {
    category: 'Rooms',
    options: [
      { value: 'reception_room', label: 'Reception', width: 120, height: 100 },
      { value: 'lobby_room', label: 'Lobby', width: 120, height: 100 },
      { value: 'party_hall_room', label: 'Party Hall', width: 160, height: 120 },
      { value: 'dj_room', label: 'DJ', width: 80, height: 80 },
      { value: 'bar_room', label: 'Bar', width: 120, height: 80 },
      { value: 'lounge_room', label: 'Lounge', width: 120, height: 100 },
      { value: 'toilet_room', label: 'Toilet', width: 80, height: 80 },
      { value: 'kitchen_room', label: 'Kitchen', width: 140, height: 100 },
      { value: 'store_room', label: 'Store', width: 100, height: 80 },
    ],
  },
  {
    category: 'Decor',
    options: [
      { value: 'plant', label: 'Plant', width: 40, height: 40, lockAspect: true },
      { value: 'statue', label: 'Statue', width: 40, height: 40, lockAspect: true },
      { value: 'vase', label: 'Vase', width: 30, height: 30, lockAspect: true },
    ],
  },
  {
    category: 'Partitions',
    options: [
      { value: 'partition_dotted_line', label: 'Dotted Line', width: 120, height: 6 },
      { value: 'partition_solid_line', label: 'Solid Line', width: 120, height: 6 },
      { value: 'partition_square', label: 'Square', width: 80, height: 80, lockAspect: true },
      { value: 'partition_rectangle', label: 'Rectangle', width: 120, height: 80 },
      { value: 'partition_circle', label: 'Circle', width: 80, height: 80, lockAspect: true },
      { value: 'partition_semi_circle', label: 'Semi Circle', width: 80, height: 40 },
    ],
  },
  {
    category: 'Equipment',
    options: [
      { value: 'vending_machine', label: 'Vending Machine', width: 40, height: 60 },
      { value: 'ice_cream_dispenser', label: 'Ice Cream Dispenser', width: 40, height: 60 },
    ],
  },
];

const allOptions = ELEMENT_CATEGORIES.flatMap((c) => c.options);

export const ELEMENT_LABELS = Object.fromEntries(allOptions.map((o) => [o.value, o.label]));

export const ELEMENT_DEFAULT_SIZES = Object.fromEntries(
  allOptions.map((o) => [o.value, { width: o.width, height: o.height }])
);

export const ELEMENT_LOCK_ASPECT = new Set(allOptions.filter((o) => o.lockAspect).map((o) => o.value));

export const DEFAULT_ELEMENT_TYPE = ELEMENT_CATEGORIES[0].options[0].value;

// Partitions render as plain CSS shape outlines (lines/boxes/circles that fill the element's own
// width/height) rather than a centered icon glyph — a "wall segment" needs to scale with
// whatever size staff drags it to, not look like a small fixed-size icon.
export const isPartitionType = (type) => typeof type === 'string' && type.startsWith('partition_');
